{
  "$id": "module://email-template",
  "$schema": "wealthlane://schemas/domain",
  "title": "Email Template",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "notificationType": {
      "type": "string",
      "title": "",
      "widget": "label",
      "adapterProps": {
        "hideLabel": true,
        "variant": "h4"
      }
    },
    "isActive": {
      "type": "boolean",
      "title": "Is Active",
      "widget": "select",
      "options": [
        { "label": "Yes", "value": true },
        { "label": "No", "value": false }
      ]
    },
    "message": {
      "type": "string",
      "title": "Editor",
      "widget": "template-richtext",
      "adapterProps": {
        "variables": [
          "ReceiverName",
          "ApproverName",
          "RejectionRemarks",
          "Title",
          "ParticipantFullName",
          "EmployerName",
          "NavigationLink",
          "ActivationCode",
          "Remarks",
          "ReceiverFullName",
          "OTP",
          "ExpiryTimeInMinutes",
          "CustomerUserName",
          "ApprovalProcess",
          "RoleName",
          "RejectedBy",
          "EmployeeId",
          "PlanName",
          "Message",
          "Name",
          "Date",
          "ParticipantName",
          "PerformanceRuleName",
          "Receiverfullname",
          "Navigationlink",
          "Receiverusername",
          "NumberOfDays",
          "ExpiredDate"
        ],
        "variableFormat": "mustache"
      }
    },
    "messagePreview": {
      "type": "string",
      "title": "Preview",
      "widget": "html-preview",
      "adapterProps": {
        "sourceField": "message"
      }
    }
  }
}
